window.addEventListener('load', () => {
	const video = document.getElementById('em-video');
	const playPauseBtn = document.getElementById('playPauseBtn');
	const seekBar = document.getElementById('seekBar');

	if (!video) {
		return;
	}

	function updateRangeBackground() {
		const value = (seekBar.value - seekBar.min) / (seekBar.max - seekBar.min);
		seekBar.style.background = `linear-gradient(to right, #ed6c2d 0%, #ed6c2d ${value * 100}%, rgba(255, 255, 255, 0) ${value * 100}%, rgba(255, 255, 255, 0) 100%)`;
	}

	playPauseBtn.addEventListener('click', () => {
		if (video.paused) {
			video.play();
			playPauseBtn.classList.remove('fa-play');
			playPauseBtn.classList.add('fa-pause');
		} else {
			video.pause();
			playPauseBtn.classList.remove('fa-pause');
			playPauseBtn.classList.add('fa-play');
		}
	});

	video.addEventListener('timeupdate', () => {
		const { currentTime } = video;
		const { duration } = video;
		seekBar.value = (currentTime / duration) * 100;
		updateRangeBackground();
	});

	seekBar.addEventListener('input', () => {
		const seekTo = video.duration * (seekBar.value / 100);
		video.currentTime = seekTo;
		const value = (seekBar.value - seekBar.min) / (seekBar.max - seekBar.min);
		const percent = value * 100;
		console.log(percent);
		seekBar.style.background = `linear-gradient(to right, #ff6100 0%, #ff6100 ${percent}%, rgba(255, 255, 255, 0.5) ${percent}%, rgba(255, 255, 255, 0.5) 100%)`;
	});
});
